import React from 'react';
import { Modal, Spin, Typography, Row, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons'; // Ant Design's Loading Icon

const { Text } = Typography;

const CustomLoadingModal = ({ visible, loading, message }) => {
  return (
    <Modal
      title="Processing..."
      visible={visible}
      footer={null}
      centered
      closable={false} // Disable close button
      width={300} // Set width to make it look better
      style={{ textAlign: 'center' }} // Center content
      bodyStyle={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
      }}
    >
      <Row justify="center" align="middle" style={{ minHeight: '100px' }}>
        <Col>
          <Spin
            spinning={loading}
            indicator={<LoadingOutlined style={{ fontSize: 36, color: '#1890ff' }} />}
            style={{ marginBottom: 20 }}
          />
         
        </Col>
      </Row>
      <Row justify="center" align="middle" style={{ minHeight: '100px' }}>
        <Col>
          
          <Text style={{ fontSize: 16, color: '#1890ff', fontWeight: '500' }}>
            {message || 'Please wait...'} {/* Display message */}
          </Text>
        </Col>
      </Row>
    </Modal>
  );
};

export default CustomLoadingModal;
